import { Activity } from '../types/GrooverTypes'

export const isActivityFree = (
  activity: Activity,
  selectedActivities: Activity[] = [],
  allActivities?: Activity[] | null
): boolean => {
  if (activity.eventType === 'Parentevent') {
    if (allActivities) {
      const hasAnyPaidChildActivity = allActivities.some((a) => a.subeventParentId === activity.id && a.price > 0)
      if (hasAnyPaidChildActivity) return false
    }
    return !selectedActivities.some((a) => a.price > 0)
  }
  return activity.price === 0
}

/** True when the root activity or any selected activity (e.g. a parent-event subevent) has a non-zero price. */
export const hasPricedSelectedActivity = (
  activity: Activity | undefined,
  selectedActivities: Activity[] = []
): boolean => {
  if ((activity?.price ?? 0) !== 0) return true
  return selectedActivities.some((selected) => (selected.price ?? 0) !== 0)
}
